module.exports = __webpack_public_path__ + "static/large-screen-one.fdb26333.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/large-screen-one.svg
// module id = 915
// module chunks = 35783957827783 112643250470497